import { render, staticRenderFns } from "./India.vue?vue&type=template&id=ea246882&"
import script from "./India.vue?vue&type=script&lang=js&"
export * from "./India.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports